import sileo from 'sileo';

const EmployeeAnalytics = new sileo.Model('hqzen', 'employee-analytics');
const EmployeeTasksLogs = new sileo.Model('hqzen', 'employee-top-tasks');
const EmployeeNoTasksLogs = new sileo.Model('hqzen', 'employee-no-task-logs');
const EmployeeAttendance = new sileo.Model('hqzen', 'employee-attendance');
const EmployerDepartment = new sileo.Model('hqzen', 'list-departments');
const EmployerTeam = new sileo.Model('hqzen', 'requests-teams');
const EmployerFeaturesAnalytical = new sileo.Model('hqzen', 'overview-employer-analytical');
const EmployerAttendance = new sileo.Model('hqzen', 'overview-employer-attendance');
const EmployerAttendanceTrend = new sileo.Model('hqzen', 'employer-total-attendance');
const ExecutiveAttendance = new sileo.Model('hqzen', 'executive-admin-attendance');
const TimeLogActivity = new sileo.Model('hqzen', 'executive-timelog-activity');
const Employee = new sileo.Model('hqzen', 'executive-employees');
const EmployeesWithNoTaskResource = new sileo.Model('hqzen', 'employee-with-no-task-selected');
const AssignedHRAdmin = new sileo.Model('hqzen','assigned-hr-admin');

const OverviewActivity = new sileo.Model('hqzen', 'overview-activity');
const ExecutiveEmployeeTimeLogs = new sileo.Model('hqzen', 'executive-employee-timelog');
const ExecutiveOverviewTimelogs = new sileo.Model('hqzen', 'timelogs-widget');
const JobApplications = new sileo.Model('hqzen', 'job-applications');
const ExpiringContracts = new sileo.Model('hqzen', 'expiring-contracts');
const ScheduledTasks = new sileo.Model('hqzen', 'scheduled-tasks');
const EmployeeActivities = new sileo.Model('hqzen', 'employee-activities');
const EmployeeMilestones = new sileo.Model('hqzen', 'employee-milestones');
const EmployeeTimelogs = new sileo.Model('hqzen', 'employee-timelog');
const EmployeeTopFiveTasks = new sileo.Model('hqzen', 'employee-top-five-tasks');
const EmployeeScheduledTasks = new sileo.Model('hqzen', 'employee-scheduled-tasks');
const ManagerSupervisorOverviewIRsAndDAFs = new sileo.Model('hqzen', 'manager-supervisor-irs-dafs');
const RecruitmentRequestDetails = new sileo.Model('hqzen', 'recruitment-request-details');

const EmployeesUnproductiveActivities = new sileo.Model('hqzen', 'manager-supervisor-unproductive-activities');
const EmployeesActivities = new sileo.Model('hqzen', 'manager-supervisor-employee-activities');
const EmployeeHoursLogged = new sileo.Model('hqzen', 'manager-supervisor-employee-hours');
const JobPostings = new sileo.Model('hqzen', 'manager-supervisor-job-applications');

const ExecutiveOverviewWorkforce = new sileo.Model(
    'hqzen', 'executive-overview-workforce');
const ExecutiveOverviewDepartment = new sileo.Model(
    'hqzen', 'executive-overview-department');
const ExecutiveOverviewTeam = new sileo.Model(
    'hqzen', 'executive-overview-team');
const ExecutiveEmployees = new sileo.Model(
    'hqzen', 'executive-overview-employees');

const HRResignation = new sileo.Model('hqzen', 'hr-resignation');
const EmploymentPolicyUpdate = new sileo.Model('hqzen', 'employment-policy-update');
const EmployeeContractExpiration = new sileo.Model('hqzen', 'employee-contract-expiration');
const DesktopUnproductiveSite = new sileo.Model('hqzen', 'desktop-unproductive-site');
const MobilePopupcount = new sileo.Model('hqzen', 'mobile-popup-count');
const Teams = new sileo.Model('hqzen', 'hr-admin-team');
const Departments = new sileo.Model('hqzen', 'hr-admin-department');
const HRAdminWidgets = new sileo.Model('hqzen', 'hr-admin-widgets');
const OverviewsWidgets = new sileo.Model('hqzen', 'executive-widgets');
const EmploymentPolicies = new sileo.Model('hqzen', 'hr-employment-policy');
const ApplicantProfile = new sileo.Model('hqzen', 'hr-admin-employee-details');
const Screenshots = new sileo.Model('hqzen', 'overview-screenshots');

const ExecutiveUnproductiveSites = new sileo.Model('hqzen', 'executive-view-unproductive');
const ExecutiveViewEmployees = new sileo.Model('hqzen', 'executive-view-employees');
const EmployeeWorkDetails = new sileo.Model('hqzen', 'employee-statistics');
const ExecutiveEmployeesWithNoTaskResource = new sileo.Model('hqzen', 'executive-view-no-task');

const EmployeeInformation = new sileo.Model('hqzen', 'employee-information');
const ManagerSupervisorOverviewAttendance = new sileo.Model('hqzen', 'manager-supervisor-dashboard-attendance');
const LatestScreenshots = new sileo.Model('hqzen', 'overview-screeenshots-page');
const EmployeesWithPlatformSettings = new sileo.Model('hqzen', 'employees-with-platform-settings');
const OverviewActivities = new sileo.Model('hqzen', 'overview-activities');
const OverviewActivitiesEmployee = new sileo.Model('hqzen', 'overview-activities-employees');
const OverviewUpcomingHolidays = new sileo.Model('hqzen', 'overview-upcoming-holidays');
const SMELatestScreenshots = new sileo.Model('hqzen', 'sme-overview-latest-screenshots');
const SMEOverviewEmployeeList = new sileo.Model('hqzen', 'sme-overview-employee-list');
const SMEIncidentReports = new sileo.Model('hqzen', 'sme-incident-report');
const SMEOnLeaveTabList = new sileo.Model('hqzen', 'sme-on-leave-tab-list');
const SMEIncideReportsSummary = new sileo.Model('hqzen', 'sme-incident-report-summary');
const SMEIncidentReportsDepartment = new sileo.Model('hqzen', 'sme-department-ir-list');

const EmployeeDesktopTimerAlertLogs = new sileo.Model('timelogging', 'employee-desktop-timer-alert-logs');

const SpecialistChat = new sileo.Model('hqzen', 'specialist-chat');
const RecruitmentRequest = new sileo.Model('hqzen', 'recruitment-request');

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getEmployeeInformation(context, pk) {
        return EmployeeInformation.objects.get(pk);
    },

    fetchScreenshots(context, filters) {
        return Screenshots.objects.filter(filters);
    },

    getEmployeeWorkDetails(context, pk) {
        return EmployeeWorkDetails.objects.get(pk);
    },

    fetchEmployeeContractExpiration(context, filters) {
        return EmployeeContractExpiration.objects.filter(filters);
    },

    fetchEmployeeAttendance(context,filters) {
        return EmployeeAttendance.objects.filter(filters);
    },

    fetchEmployeeAnalytics(context) {
        return EmployeeAnalytics.objects.filter();
    },

    fetchIndividualEmployeeTaskLogs(context, filters) {
        return EmployeeTasksLogs.objects.filter(filters);
    },

    fetchEmployeeNoTasksLogs(context, filters) {
        return EmployeeNoTasksLogs.objects.filter(filters);
    },

    fetchEmployerDepartments(context, filters) {
        return EmployerDepartment.objects.filter(filters);
    },

    fetchEmployerTeams(context, filters) {
        return EmployerTeam.objects.filter(filters);
    },

    employerFetchAllCount(context, filters) {
        return EmployerFeaturesAnalytical.objects.filter(filters);
    },

    fetchAttendance(context, filters) {
        return EmployerAttendance.objects.filter(filters);
    },

    async fetchTotalAttendance(context, filters) {
        return await EmployerAttendanceTrend.objects.filter(filters);
    },

    fetchExecutiveAttendance(context, filters) {
        return ExecutiveAttendance.objects.filter(filters);
    },

    fetchTimeLogActivities(context, filters) {
        return TimeLogActivity.objects.filter(filters);
    },

    fetchEmployees(context, filters) {
        return Employee.objects.filter(filters);
    },

    fetchOverviewActivity(context, filters) {
        return OverviewActivity.objects.filter(filters);
    },

    fetchExecutiveEmployeeTimelogs(context, filters) {
        return ExecutiveEmployeeTimeLogs.objects.filter(filters);
    },

    fetchTimelogs(context, filters) {
        return ExecutiveOverviewTimelogs.objects.filter(filters);
    },

    fetchExecutiveEmployees(context, filters) {
        return ExecutiveEmployees.objects.filter(filters);
    },

    fetchExecutiveOverviewWorkforces(context, filters) {
        return ExecutiveOverviewWorkforce.objects.filter(filters);
    },

    fetchExecutiveEmployeeWithNoTask(context, filters) {
        return ExecutiveEmployeesWithNoTaskResource.objects.filter(filters);
    },

    fetchExecutiveOverviewDepartments(context, filters) {
        return ExecutiveOverviewDepartment.objects.filter(filters);
    },

    fetchExecutiveOverviewTeams(context, filters) {
        return ExecutiveOverviewTeam.objects.filter(filters);
    },

    fetchHRResignations(context, filters) {
        return HRResignation.objects.filter(filters);
    },
    fetchJobApplications(context,filters) {
        return JobApplications.objects.filter(filters);
    },

    fetchExpiringContracts(context,filters) {
        return ExpiringContracts.objects.filter(filters);
    },

    updateHRAdminsOnEmploymentPolicy(context, data) {
        let filters = {
            employment_policy_ids: data.employmentPolicyIds,
            assigned_hrs_user_profile_ids: data.assignedHrsUserProfileIds,
            resigning_hr_admin_id: data.resigningHrAdminId
        };
        EmploymentPolicyUpdate.objects.update(filters);
    },

    updateSeparation(context, data) {
        const form = new FormData();
        form.append('is_acknowledged', data.isAcknowledged);
    HRResignation.objects.update({ 'pk': data.separationId }, form);
    },

    fetchDesktopUnproductiveSite(context, filters) {
        return DesktopUnproductiveSite.objects.filter(filters);
    },

    fetchMobilePopupCount(context, filters) {
        return MobilePopupcount.objects.filter(filters);
    },

    // async fetchManagerSupervisorAttendance(context, filters) {
    //     return await ManagerSupervisorOverviewAttendance.objects.filter(filters);
    // },

    fetchManagerSupervisorAttendance(context, filters) {
        return ManagerSupervisorOverviewAttendance.objects.filter(filters);
    },

    async fetchEmployeesWithNoTask(context, filters) {
        return EmployeesWithNoTaskResource.objects.filter(filters);
    },

    fetchExecutiveUnproductiveSites(context, filters) {
        return ExecutiveUnproductiveSites.objects.filter(filters);
    },

    fetchEmployeeScheduledTasks(context, filters) {
        return EmployeeScheduledTasks.objects.filter(filters);
    },

    fetchHRAdminWidgets(context, filters) {
        return HRAdminWidgets.objects.filter(filters);
    },

    fetchOverviewsWidgets(context, filters) {
        return OverviewsWidgets.objects.filter(filters);
    },

    fetchEmploymentPolicies(context, filters) {
        return EmploymentPolicies.objects.filter(filters);
    },

    async fetchApplicant(context, user_pk) {
        return await ApplicantProfile.objects.get(user_pk).then(
            data => {
                return data;
            }
        );
    },

    fetchScheduledTasks(context, filters) {
        return ScheduledTasks.objects.filter(filters);
    },

    fetchEmployeeActivities(context, filters) {
        return EmployeeActivities.objects.filter(filters);
    },

    fetchEmployeeMilestones(context, filters) {
        return EmployeeMilestones.objects.filter(filters);
    },

    fetchEmployeeTimelogs(context, filters) {
        return EmployeeTimelogs.objects.filter(filters);
    },

    fetchEmployeeTopFiveTasks(context, filters) {
        return EmployeeTopFiveTasks.objects.filter(filters);
    },

    fetchExecutiveViewEmployees(context, filters) {
        return ExecutiveViewEmployees.objects.filter(filters);
    },

    fetchSingleEmployment(context, pk) {
        return ExecutiveEmployees.objects.get(pk);
    },

    fetchTeams(context, filters) {
        return Teams.objects.filter(filters);
    },

    fetchDepartments(context, filters) {
        return Departments.objects.filter(filters);
    },

    fetchManagerSupervisorIRsAndDAFs(context, filters) {
        return ManagerSupervisorOverviewIRsAndDAFs.objects.filter(filters);
    },

    validateHRAdmin(context, filters) {
        return AssignedHRAdmin.objects.filter(filters);
    },

    fetchLatestScreenshots(context, filters) {
        return LatestScreenshots.objects.filter(filters);
    },

    fetchEmployeesWithPlatformSettingsTemplate(context, filters) {
        return EmployeesWithPlatformSettings.objects.filter(filters);
    },

    fetchOverviewActivities(context, filters) {
        return OverviewActivities.objects.filter(filters);
    },

    fetchOverviewActivityEmployees(context, filters) {
        return OverviewActivitiesEmployee.objects.filter(filters);
    },

    fetchOverviewUpcomingHolidays(context, filters) {
        return OverviewUpcomingHolidays.objects.filter(filters);
    },

    fetchEmployeesUnproductiveActivities(context, filters) {
        return EmployeesUnproductiveActivities.objects.filter(filters);
    },

    fetchEmployeesActivities(context, filters) {
        return EmployeesActivities.objects.filter(filters);
    },

    fetchEmployeeHours(context, filters) {
        return EmployeeHoursLogged.objects.filter(filters);
    },

    fetchJobPostings(context, filters) {
        return JobPostings.objects.filter(filters);
    },

    fetchSMELatestScreenshots(context, filters) {
        return SMELatestScreenshots.objects.filter(filters);
    },

    fetchSMEOverviewEmployeeList(context, filters) {
        return SMEOverviewEmployeeList.objects.filter(filters);
    },

    fetchIncidentReports(context, filters) {
        return SMEIncidentReports.objects.filter(filters);
    },

    fetchEmployeeDesktopTimerAlertLogs(context, filters) {
        return EmployeeDesktopTimerAlertLogs.objects.filter(filters);
    },

    fetchSMEOnLeaveTabList(context, filters) {
        return SMEOnLeaveTabList.objects.filter(filters);
    },

    fetchSMEIncidentReportsSummary(context, filters) {
        return SMEIncideReportsSummary.objects.filter(filters);
    },

    fetchSMEIncidentReportsDepartments(context, filters) {
        return SMEIncidentReportsDepartment.objects.filter(filters);
    },

    fetchRecruitmentRequests(context, filters) {
        return RecruitmentRequest.objects.filter(filters);
    },

    fetchRecruitmentRequestDetails(context, pk) {
        return RecruitmentRequestDetails.objects.get(pk);
    },

    removeRecruitmentRequest(context, pk) {
        return RecruitmentRequest.objects.delete({ pk });
    },

    fetchSpecialistChat(context, filters) {
        return SpecialistChat.objects.filter(filters);
    },

    createRecruitmentRequest(context, data) {
        const form = new FormData();

        for (const [key, value] of Object.entries(data)) {
            form.append(key, value);
        }

        return RecruitmentRequest.objects.create(form);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
